module.exports = __webpack_public_path__ + "img/shousai.3a188920.png";